(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bis-modal"]) return;
  try {
    
  if(!customElements.get('bis-modal')) {
    class bisModal extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.bisForm = this.querySelector('form');
        this.productTitle = this.querySelector('[data-product-title]');
        this.variantName = this.querySelector('[data-product-variant]');
        this.variantId = this.querySelector('[data-bis-variant-id]');
        this.productId = this.querySelector('[data-bis-product-id]');
        this.bisTypeSelectors = this.querySelectorAll('input[type="radio"]');
        this.closeButton = this.querySelector('[data-close-button]');
        this.newsletterCheckbox = this.querySelector('[data-consent-checkbox]');
        this.smsDisclaimer = this.querySelector('[data-sms-disclaimer]');
        this.zipCodeField = this.querySelector('[data-zip-code-field]');
        this.phoneNumberInput = this.querySelector('input[type="tel"]');

        if(this.phoneNumberInput) {
          this.intlPhoneNumberSelector();
        }

        document.addEventListener('bisForm:open', this.openModal.bind(this));

        this.bisTypeSelectors.forEach((radio) => {
          radio.addEventListener('change', (evt) => {
            let emailAction = 'remove';
            let smsAction = 'add';
            let emailSelector = this.querySelector('input[type="email"]');
            let smsSelector = this.querySelector('input[type="tel"]');
            let smsWrapper = smsSelector.closest('.iti');
            if(evt.target.value == 'sms') {
              emailAction = 'add';
              smsAction = 'remove';
            }
            emailSelector.classList[emailAction]('hidden');
            smsWrapper.classList[smsAction]('hidden');
            this.smsDisclaimer.classList[smsAction]('hidden');
          })
        })
        this.bisForm?.addEventListener('submit', this.submitModal.bind(this));
        this.closeButton.addEventListener('click', this.closeModal.bind(this));
      }

      openModal(evt) {
        const info = evt.detail;

        this.productTitle.innerText = info.productTitle;
        this.variantName.innerText = info.variantTitle;
        this.productId.value = info.productId;
        this.variantId.value = info.variantId;

        this.dialog.showModal();
      }

      closeModal() {
        this.dialog.close();
      }

      intlPhoneNumberSelector() {
        if(!window.intlTelInput) {
          setTimeout(() => {
            this.intlPhoneNumberSelector();
          }, 200)
        } else {
          const activeSelector = Array.from(this.bisTypeSelectors).filter((element) => element.checked == true);
          this.bisPhone = window.intlTelInput(this.querySelector('input[type="tel"]'), {
            initialCountry: Shopify.country,
            containerClass: activeSelector.value == 'email' ? 'hidden' : '',
            loadUtils: () => import(window.intlTelInputUtils),
          })
        }
      }

      validateFields() {
        const inputs = Array.from(this.querySelectorAll('input[required]')).filter((input) => {
          if(input.classList.contains('iti__tel-input')) {
            return !input.parentElement.classList.contains('hidden');
          } else {
            !input.classList.contains('hidden')
          }
        });
        let formValid = true;

        inputs.forEach((input) => {
          if(!input.checkValidity()) {
            if(formValid) {
              input.focus();
            }

            formValid = false;
            input.classList.add('has-error');
            input.addEventListener('keyup', (evt) => {
              evt.target.classList.remove('has-error');
            }, {once: true} )
          }
        })

        return formValid;
      }

      updateFormMessage({
        message,
        success
      }) {
        const confirmMessage = this.querySelector("[data-confirm-message]");
        const successIcon = this.querySelector(".bis-modal-form__confirm-message svg");

        if(!success) {
          successIcon.style.display = "none";
          confirmMessage.style.color = "var(--color-error)"
        }

        confirmMessage.innerHTML = message;
        confirmMessage.parentElement.removeAttribute('hidden');

        setTimeout(() => {
          confirmMessage.parentElement.setAttribute('hidden', true);
          confirmMessage.removeAttribute('style');
          successIcon.removeAttribute('style');
        }, 5000);
      }

      submitModal(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const validForm = this.validateFields();

        if(!validForm) {
          this.updateFormMessage({
            message: "All fields are required",
            success: false
          })
          return;
        }

        const selectedType = Array.from(this.bisTypeSelectors).find(
          (selector) => selector.checked
        );
        const zipCode = this.zipCodeField?.value;

        const payload = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: [],
              profile: {
                data: {
                  type: "profile",
                  attributes: {},
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${this.variantId.value}`,
                },
              },
            },
          },
        };

        const consentPayload = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    subscriptions: {},
                    properties: {},
                  },
                },
              },
              custom_source: "Back in stock form",
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: "V3hrKA",
                },
              },
            },
          },
        };

        const updatePayload = {
          data: {
            type: "profile",
            attributes: {
              properties: {},
            }
          }
        }

        if (!selectedType || selectedType.value == "email") {
          const email = this.bisForm.querySelector('input[type="email"').value;

          payload.data.attributes.channels.push("EMAIL");
          payload.data.attributes.profile.data.attributes.email = email;

          if(this.newsletterCheckbox.checked == true) {
            consentPayload.data.attributes.profile.data.attributes.subscriptions = {
              email: {
                marketing: {
                  consent: "SUBSCRIBED",
                }
              }
            }

            consentPayload.data.attributes.profile.data.attributes.email = email;
            if(zipCode) {
              consentPayload.data.attributes.profile.data.attributes.properties["zip-code"] = zipCode;
            }
          } else {
            updatePayload.data.attributes.email = email;

            if(zipCode) {
              updatePayload.data.attributes.properties["zip-code"] = zipCode;
            }
          }
        } else if (selectedType.value == "sms") {
          let phone = this.bisPhone.getNumber();

          payload.data.attributes.channels.push("SMS");
          payload.data.attributes.profile.data.attributes.phone_number = phone;

          if(this.newsletterCheckbox.checked == true) {
            consentPayload.data.attributes.profile.data.attributes.subscriptions = {
              sms: {
                marketing: {
                  consent: "SUBSCRIBED",
                }
              }
            }

            consentPayload.data.attributes.profile.data.attributes.phone_number = phone;
            if(zipCode) {
              consentPayload.data.attributes.profile.data.attributes.properties["zip-code"] = zipCode;
            }
          } else {
            updatePayload.data.attributes.phone_number = phone;

            if(zipCode) {
              updatePayload.data.attributes.properties["zip-code"] = zipCode;
            }
          }
        }

        fetch(
          "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=KkSJyW",
          {
            headers: {
              accept: "application/vnd.api+json",
              "content-type": "application/vnd.api+json",
              revision: "2025-04-15",
            },
            method: "post",
            body: JSON.stringify(payload),
          }
        ).then(async (data) => {
          if (data.status == 202) {
            // Subscribe the customer to the newsletter if the BIS subscripton was successful
            if(this.newsletterCheckbox.checked == true) {
              fetch("https://a.klaviyo.com/client/subscriptions?company_id=KkSJyW", {
                headers: {
                  accept: "application/vnd.api+json",
                  "content-type": "application/vnd.api+json",
                  revision: "2025-07-15"
                },
                method: "post",
                body: JSON.stringify(consentPayload)
              }).then(async (data) => {
                if (data.status !== 202) {
                  const response = await data.json();
                  const errorsMsg = response.errors.map((error) => {
                    return error.detail;
                  })

                  console.log('[BIS form] - Error subscribing to newsletter'),
                  console.log(errorsMsg)
                }
              })
            } else if(zipCode) {
              fetch("https://a.klaviyo.com/client/profiles?company_id=KkSJyW", {
                headers: {
                  accept: "application/vnd.api+json",
                  "content-type": "application/vnd.api+json",
                  revision: "2025-07-15"
                },
                method: "post",
                body: JSON.stringify(updatePayload)
              })
            }


            this.updateFormMessage({
              message: "We'll Notify You When It's Back In Stock",
              success: true,
            })
          } else {
            const response = await data.json();
            const errorsMsg = await response.errors.map((error) => {
              return error.detail;
            });
            this.updateFormMessage({
              message: errorsMsg.join("<br/>"),
              success: false
            })
          }
        });
      }
    }

    customElements.define('bis-modal', bisModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if(!customElements.get('cart-drwer')) {
    class CartDrawer extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.abortController = new AbortController();
        this.referrer = null;

        this.connectWithStoreModule();

        this.toggleButtons = document.querySelectorAll('[data-cart-close], [data-cart-drawer-toggle]');

        this.toggleButtons.forEach((button) => {
          button.addEventListener('click', this.toggleHandler.bind(this), {
            signal: this.abortController.signal
          })
        })

        this.addEventListener('keyup', this.keyupHandler.bind(this), {
          signal: this.abortController.signal
        })
      }

      keyupHandler(evt) {
        if(evt.key == "Escape") {
          evt.preventDefault();
          this.storeModule.dispatch('cartVisible', false);
        }
      }

      toggle() {
        const isOpen = store.state.cartVisible;

        this.classList.toggle('cart-open', isOpen);
        if(!isOpen) {
          this.referrer.focus();
        } else {
          this.referrer = document.activeElement
          this.toggleButtons[0].focus();
        }
      }

      toggleHandler(evt) {
        evt.preventDefault();

        store.dispatch('cartVisible', !store.state.cartVisible);
      }

      connectWithStoreModule() {
        if(this.storeModule) return;
        if(window.storeModule?.events) {
          this.storeModule = window.storeModule;
          this.storeModule.events.subscribe('cartVisibleChange', this.toggle.bind(this));
        } else {
          setTimeout(() => {
            this.connectWithStoreModule();
          }, 500);
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if(!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super()

        this.selectors = {
          barCloseButton: '[data-header-bar-close]',
          navMobile: '[data-nav-mobile]',
          navMobileBack: '[data-nav-mobile-back]',
          navMobileButton: '[data-nav-button]',
          navMobileOverlay: '[data-nav-mobile-overlay]',
          headerBar: '[data-header-bar]',
          linkWithDropdown: '[data-link-has-dropdown]',
          adaDrawerToggler: '[data-ada-drawer-toggler]',
          navMobileDropdown: '[data-nav-mobile-dropdown]',
          mobileChatButton: '[data-mobile-chat-button]',
          navFirstLevelButton: '[data-nav-link-has-second-level]',
          navSecondLevelLink: '[data-nav-second-level-link]',
          navSecondLevelWrapper: '[data-nav-second-level-wrapper]',
          navOverlay: '[data-nav-overlay]',
          navThirdLevelMegamenu: '[data-nav-third-level-megamenu]',
          headerContainer: "[data-header-container]",
          navDrawer: '[data-nav-drawer]',
          navDrawerClose: '[data-nav-drawer-close]',
          navLevel2Link: '[data-nav-level2-link]',
        }
        this.classes = {
          headerNavOpen: 'is-nav-open',
          headerScrolled: 'is-scrolled',
          navMobileActive: 'is-visible',
          navMobileDropdownBehind: 'under',
          navMobileDropdownVisible: 'current',
          navMobileButtonActive: 'is-active',
          hidden: 'hidden',
          navLinkOpen: 'nav__link--opened',
          navDrawerOpened: 'nav__drawer--opened',
          navDrawerNoTransition: 'nav__drawer--no-transition',
        }
      }

      connectedCallback() {

        // Elements
        this.barCloseButton = this.querySelector(this.selectors.barCloseButton)
        this.headerBar = this.querySelector(this.selectors.headerBar)
        this.navMobile = this.querySelector(this.selectors.navMobile)
        this.navMobileButton = this.querySelector(this.selectors.navMobileButton)
        this.navMobileOverlay = this.querySelector(this.selectors.navMobileOverlay)
        this.navMobileDropdown = Array.from(this.querySelectorAll(this.selectors.navMobileDropdown))
        this.navOverlay = this.querySelector(this.selectors.navOverlay);
        this.adaDrawerTogglers = this.querySelectorAll(this.selectors.adaDrawerToggler);
        this.stickyHeader = document.querySelector('sticky-header');

        // Handlers
        this.onScrollHandler = this.onScroll.bind(this)
        this.onBarCloseHandler = this.barClose.bind(this)
        this.toggleMenuHandler = this.toggleMenu.bind(this)
        this.linkWithDropdownHandler = this.linkWithDropdownOnClick.bind(this)
        this.toggleChatHandler = this.toggleChat.bind(this)
        this.collapseMobileDropdownsHandler =
          this.collapseMobileDropdowns.bind(this)
        this.onEarlyAccessEnableHandler = this.onEarlyAccessEnable.bind(this);
        this.navDrawerCloseHandler = this.closeNavDrawer.bind(this);
        this.navFirstLevelHoverHandler = this.navFirstLevelHover.bind(this);
        this.navFirstLevelKeyDownHandler = this.navFirstLevelKeyDown.bind(this);
        this.onKeyDownHandler = this.onKeyDown.bind(this);
        this.navOverlayMouseEnterHandler = this.navOverlayMouseEnter.bind(this);

        // Ref
        this.pastDropdowns = this.navMobileDropdown.filter((dropdown) => dropdown.hasAttribute('data-base-layer'));

        window.addEventListener('scroll', this.onScrollHandler, false)
        window.addEventListener('load', this.onScrollHandler, false)
        window.addEventListener('enableEarlyAccess', this.onEarlyAccessEnableHandler, false)
        document.addEventListener('keydown', this.onKeyDownHandler, false)
        this.barCloseButton.addEventListener('click', this.onBarCloseHandler, false)
        this.navMobileButton.addEventListener('click', this.toggleMenuHandler, false)
        this.navMobileOverlay.addEventListener('click', (e) => {
          this.toggleMenuHandler(e, true)
        }, false)

        this.querySelectorAll(this.selectors.linkWithDropdown).forEach((link) => {
          link.addEventListener('click', this.linkWithDropdownHandler)
        })
        this.querySelectorAll(this.selectors.navMobileBack).forEach((button) => {
          button.addEventListener('click', this.collapseMobileDropdownsHandler)
        })
        this.querySelectorAll(this.selectors.mobileChatButton).forEach((button) => {
          button.addEventListener('click', this.toggleChatHandler);
        })

        this.headerBarClosed = window.sessionStorage.getItem('header-bar-closed')

        if (
          !this.headerBarClosed &&
          this.querySelector(this.selectors.headerBar).classList.contains(
            'has-content'
          )
        ) {
          this.headerBar.classList.remove(this.classes.hidden)
        }

        this.earlyAccessSession = window.sessionStorage.getItem('earlyAccess')
        if(this.earlyAccessSession) {
          this.onEarlyAccessEnable();
        }

        this.adaDrawerTogglers.forEach((button) => {
          button.addEventListener('click', this.navFirstLevelHoverHandler);
        })

        this.querySelectorAll(this.selectors.navFirstLevelButton).forEach((link) => {
          link.addEventListener('mouseenter', this.navFirstLevelHoverHandler);
        })

        // Drawer event listeners
        this.querySelectorAll(this.selectors.navDrawerClose).forEach((button) => {
          button.addEventListener('click', this.navDrawerCloseHandler)
        })

        // Add mouse enter handler for overlay to close drawer
        const overlay = this.querySelector(this.selectors.navOverlay);
        if (overlay) {
          overlay.addEventListener('mouseenter', this.navOverlayMouseEnterHandler);
        }

        window.addEventListener("resize", () => {
          this.updateDrawerHeight();
        }, {
          passive: true
        })

        document.documentElement.style.setProperty('--header-height', this.parentElement.offsetHeight + 'px');
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler)
        window.removeEventListener('enableEarlyAccess', this.onEarlyAccessEnableHandler);
        document.removeEventListener('keydown', this.onKeyDownHandler, false);
      }

      toggleChat() {
        this.closeMenu();

        if (window.GorgiasChat) {
          window.GorgiasChat.open()
        }
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop

        this.classList.toggle(this.classes.headerScrolled, scrollTop > 0)
      }

      barClose() {
        this.headerBar.classList.add(this.classes.hidden)
        this.calcPageOffset()
        window.sessionStorage.setItem('header-bar-closed', true)
      }

      toggleMenu(e) {
        var headerHeight = this.closest('#shopify-section-header').offsetHeight
        this.navMobile.style.setProperty('--offset-top', `${headerHeight}px`);
        if(this.navMobile.classList.contains(this.classes.navMobileActive)) {
          this.closeMenu()
        } else {
          this.openMenu();
        }
      }

      openMenu() {
        this.navMobile.classList.add(this.classes.navMobileActive)
        this.navMobileButton.classList.add(this.classes.navMobileButtonActive)
        this.classList.add(this.classes.headerNavOpen)
        if(document.querySelector('#gorgias-chat-container')){
          document.querySelector('#gorgias-chat-container').style.display = "none";
        }

        if (typeof window.toggleBodyLock == 'function') {
          toggleBodyLock(this.navMobile, true);
        }
      }

      closeMenu() {
        this.navMobile.classList.remove(this.classes.navMobileActive)
        this.navMobileButton.classList.remove(this.classes.navMobileButtonActive)
        this.classList.remove(this.classes.headerNavOpen)

        this.navMobile.addEventListener('transitionend', () => {
          this.resetMobileNav();
        }, {once: true})

        if (typeof window.toggleBodyLock == 'function') {
          toggleBodyLock(this.navMobile, false);
        }

        if(document.querySelector('#gorgias-chat-container')){
          document.querySelector('#gorgias-chat-container').style.display = "block";
        }
      }

      resetMobileNav() {
        const firstLayerDropdown = this.navMobileDropdown.filter((dropdown) => dropdown.hasAttribute('data-base-layer'))
        this.pastDropdowns = firstLayerDropdown;

        this.navMobileDropdown.forEach((dropdown) => {
          dropdown.classList.remove(this.classes.navMobileDropdownVisible);
          dropdown.classList.remove(this.classes.navMobileDropdownBehind);
        })

        firstLayerDropdown[0].classList.add(this.classes.navMobileDropdownVisible);
        firstLayerDropdown[0].scrollTop = 0;
      }

      navFirstLevelButtonClick({e, link}) {
        if(e) {
          e.preventDefault();
        }

        this.closeAllMegamenus();
        this.closeAllSecondLevelNavs();
        this.deactivateFirstLevelLinks();
        this.closeNavDrawer();

        const secondLevelMenuRef = link.dataset.navLinkMenuRef;
        const isActive = link.classList.contains("nav__link--active");

        if (!isActive) {
          link.classList.add("nav__link--active");
          this.prepareNavDrawer(secondLevelMenuRef);
        }
      }

      linkWithDropdownOnClick(e) {
        e.preventDefault()

        const targetHandle = e.currentTarget.dataset.handle;

        const targetDropdown = this.navMobileDropdown.find((dropdown) => dropdown.dataset.handle === targetHandle);

        if (!targetDropdown) {
          return
        }

        this.pastDropdowns.forEach((drawer) => {
          drawer.classList.add(this.classes.navMobileDropdownBehind);
          drawer.classList.remove(this.classes.navMobileDropdownVisible);
        })

        targetDropdown.classList.add(this.classes.navMobileDropdownVisible);
        targetDropdown.scrollTop = 0;
        this.pastDropdowns.push(targetDropdown);
      }

      collapseMobileDropdowns(e) {
        const latestDropdown = this.pastDropdowns.pop();

        latestDropdown.classList.remove(this.classes.navMobileDropdownVisible);

        this.pastDropdowns.slice(-1)[0].classList.remove(this.classes.navMobileDropdownBehind);
        this.pastDropdowns.slice(-1)[0].classList.add(this.classes.navMobileDropdownVisible);
      }

      closeAllMegamenus() {
        const overlay = this.querySelector(this.selectors.navOverlay);

        overlay.classList.remove("active");

        document.querySelectorAll(this.selectors.navThirdLevelMegamenu).forEach((megamenu) => {
          megamenu.classList.remove("opened")
        })
        document.querySelectorAll(this.selectors.navSecondLevelWrapper).forEach((menu) => {
          menu.classList.remove("has-third-level-opened")
        })
        document.querySelectorAll(this.selectors.navSecondLevelLink).forEach((link) => {
          link.classList.remove("opened")
        })
      }

      closeAllSecondLevelNavs() {
        document.querySelectorAll(this.selectors.navSecondLevelWrapper).forEach((secondLevelMenu) => {
          secondLevelMenu.classList.remove("menu-level-2--opened")
        })
      }

      linkWithMegamenuOnMouseEnter(e) {
        const currentLink = e.target;
        const secondLevelWrapper = currentLink.closest(this.selectors.navSecondLevelWrapper);
        const megaMenuRef = currentLink.dataset.dropdownId;
        const thirdLevelMegamenu = currentLink.closest("[data-nav-second-level-wrapper]").querySelector(`[data-nav-third-level-megamenu="${megaMenuRef}"]`);
        const overlay = this.querySelector(this.selectors.navOverlay);
        const hasSomeThirdLevelMenuActive = this.querySelector(`${this.selectors.navThirdLevelMegamenu}.opened`);
        const hasSomeSecondLevelLinkActive = this.querySelector(`${this.selectors.navSecondLevelLink}.opened`);

        if (hasSomeThirdLevelMenuActive) {
          hasSomeThirdLevelMenuActive.classList.remove("opened");
          hasSomeSecondLevelLinkActive.classList.remove("opened");
        }

        if (!thirdLevelMegamenu) {
          secondLevelWrapper.classList.remove("has-third-level-opened");
          overlay.classList.remove("active");
          if (hasSomeSecondLevelLinkActive) {
            hasSomeSecondLevelLinkActive.classList.remove("opened");
          }
          return;
        }

        const isOpened = thirdLevelMegamenu.classList.contains("opened");
        if (!isOpened) {
          currentLink.classList.add("opened");
          thirdLevelMegamenu.classList.add("opened");
          overlay.classList.add("active");
          secondLevelWrapper.classList.add("has-third-level-opened");

          const gorgiasChatContainer = document.getElementById('gorgias-chat-container');
          if (gorgiasChatContainer) {
            gorgiasChatContainer.style.zIndex = 10;
          }
        }
      }

      linkWithMegamenuOnMouseLeave(e) {
        const currentElement = e.fromElement;
        const secondLevelLinkActive = this.querySelector(`${this.selectors.navSecondLevelLink}.opened`);
        const secondLevelWrapper = currentElement.closest(this.selectors.navSecondLevelWrapper);
        const overlay = this.querySelector(this.selectors.navOverlay);

        const gorgiasChatContainer = document.getElementById('gorgias-chat-container');
        if (gorgiasChatContainer) {
          gorgiasChatContainer.removeAttribute('style');
        }

        const isOpened = currentElement.classList.contains("opened");
        if (isOpened && e.toElement && !e.toElement.contains(currentElement)) {
          secondLevelLinkActive?.classList?.remove("opened");
          currentElement.classList.remove("opened");
          secondLevelWrapper.classList.remove("has-third-level-opened");
          overlay.classList.remove("active");
        }
      }

      calcPageOffset() {
        const main = document.querySelector('#MainContent')
        const headerHeight = this.calcHeaderHeight();

        main.style.paddingTop = `${headerHeight}px`

        this.calcAccountTop(headerHeight)
      }

      calcAccountTop(headerHeight) {
        const accountTabs = document.querySelectorAll('.js-account-tab')

        if (accountTabs && accountTabs[0]) {
          accountTabs.forEach((element) => {
            element.style.marginTop = `-${headerHeight}px`
            element.style.paddingTop = `${headerHeight}px`
          })
        }
      }

      onEarlyAccessEnable() {
        const earlyAccessButtons = this.querySelectorAll('.early-access');

        earlyAccessButtons.forEach(element => {
          element.classList.remove('hidden');
        })
      }

      openNavDrawer(drawerRef, eventType) {
        const drawer = this.querySelector(`[data-nav-drawer-ref="${drawerRef}"]`);
        const openDrawer = this.querySelector(`[data-nav-drawer].${this.classes.navDrawerOpened}`);
        this.updateDrawerHeight(drawer);

        if (drawer) {
          if(openDrawer) {
            openDrawer.classList.add(this.classes.navDrawerNoTransition);
            drawer.classList.add(this.classes.navDrawerNoTransition);
            openDrawer.classList.remove(this.classes.navDrawerOpened);
          }

          const headerHeight = this.closest('#shopify-section-header').offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
          drawer.classList.add(this.classes.navDrawerOpened);

          this.navOverlay.classList.add("active");
          if(eventType == 'click') {
            if(!openDrawer) {
              drawer.addEventListener('transitionend', () => {
                trapFocus(drawer)
              }, {once: true})
            } else {
              trapFocus(drawer);
            }
          }
        }
      }

      closeNavDrawer(shouldMovefocus = true) {
        const openDrawer = this.querySelector(`.${this.classes.navDrawerOpened}`);
        const togglerButton = this.querySelector(`[data-ada-drawer-toggler="${openDrawer.dataset.navDrawerRef}"]`)
        togglerButton.setAttribute('aria-expanded', false);

        if (openDrawer) {
          openDrawer.classList.remove(this.classes.navDrawerNoTransition)
          openDrawer.classList.remove(this.classes.navDrawerOpened);
          this.navOverlay.classList.remove('active');

          openDrawer.addEventListener('transitionend', () => {
            console.log(shouldMovefocus);
            if(shouldMovefocus) {
              removeTrapFocus(togglerButton);
            }
            this.deactivateFirstLevelLinks();
          }, {once: true})
        }
      }

      prepareNavDrawer(drawerRef) {
        const drawer = this.querySelector(`[data-nav-drawer-ref="${drawerRef}"]`);
        if (drawer) {
          const headerHeight = this.closest('#shopify-section-header').offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        }
      }

      navOverlayMouseEnter(e) {
        this.closeNavDrawer(false);
      }

      navFirstLevelHover(e) {
        const target = e.currentTarget;
        const secondLevelMenuRef = target.dataset.navLinkMenuRef;

        this.deactivateFirstLevelLinks();
        this.openNavDrawer(secondLevelMenuRef, e.type);
        target.setAttribute('aria-expanded', "true");

        target.parentElement.classList.add(this.classes.navLinkOpen);

        this.querySelector('.header__nav').classList.add('header__nav--drawer-open');
      }

      deactivateFirstLevelLinks() {
        this.querySelector('.header__nav').classList.remove('header__nav--drawer-open');
        document.querySelectorAll(this.selectors.navFirstLevelButton).forEach((firstLevelLink) => {
          firstLevelLink.parentElement.classList.remove(this.classes.navLinkOpen)
        })
      }

      navFirstLevelKeyDown(e) {
        // Check if Enter key is pressed
        if (e.key === 'Enter' || e.keyCode === 13) {
          // Get the element with data-nav-link-has-second-level (might be currentTarget or its parent)
          let navElement = e.currentTarget;

          // If the event is on a child element (like <a>), find the parent with data-nav-link-has-second-level
          if (!navElement.hasAttribute('data-nav-link-has-second-level')) {
            navElement = navElement.closest(this.selectors.navFirstLevelButton);
          }

          if (navElement && navElement.hasAttribute('data-nav-link-has-second-level')) {
            e.preventDefault();
            e.stopPropagation();
            const secondLevelMenuRef = navElement.dataset.navLinkMenuRef;

            // Close other navigation elements
            this.closeAllMegamenus();
            this.deactivateFirstLevelLinks();

            // Toggle the drawer: if already active, close it; otherwise open it
            const isActive = navElement.classList.contains("nav__link--active");

            if (isActive) {
              navElement.classList.remove("nav__link--active");
              this.closeNavDrawer();
              const overlay = this.querySelector(this.selectors.navOverlay);
              if (overlay) {
                overlay.classList.remove("active");
              }
            } else {
              navElement.classList.add("nav__link--active");
              this.openNavDrawer(secondLevelMenuRef, true);
              const overlay = this.querySelector(this.selectors.navOverlay);
              if (overlay) {
                overlay.classList.add("active");
              }
            }
          }
        }
      }

      updateDrawerHeight(drawer) {
        const maxHeight = window.innerHeight - this.stickyHeader.offsetHeight;
        if(drawer) {
          drawer.style.maxHeight = maxHeight + 'px';
        } else {
          const drawers = Array.from(this.querySelectorAll(this.selectors.navDrawer));

          drawers.forEach(drawer => {
            drawer.style.maxHeight = maxHeight + 'px';
          })

        }
      }

      onKeyDown(e) {
        // Close navigation elements when Escape key is pressed
        if (e.key === 'Escape' || e.keyCode === 27) {
          // Close drawer if open
          const openDrawer = this.querySelector(`.${this.classes.navDrawerOpened}`);
          if (openDrawer) {
            this.closeNavDrawer();
            // Also deactivate first level links and remove overlay
            this.deactivateFirstLevelLinks();
            const overlay = this.querySelector(this.selectors.navOverlay);
            if (overlay) {
              overlay.classList.remove("active");
            }
            e.preventDefault();
            return;
          }

          // Close mobile menu if open
          if (this.navMobile && this.navMobile.classList.contains(this.classes.navMobileActive)) {
            this.closeMenu();
            e.preventDefault();
            return;
          }

          // Close megamenus if open
          const hasOpenedMegamenu = this.querySelector(`${this.selectors.navThirdLevelMegamenu}.opened`);
          if (hasOpenedMegamenu) {
            this.closeAllMegamenus();
            e.preventDefault();
            return;
          }
        }
      }
    }

    customElements.define('sticky-header', StickyHeader)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-overlay"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('overlaying-mask')) {
    class OverlayingMask extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        const parentElement = this.closest('.shopify-section');
        const mainContentChildren = Array.from(document.querySelector('#MainContent').children);
        const parentElementIndex = mainContentChildren.findIndex(children => children == parentElement);
        const iconNext = this.querySelector('.icon-chevron-down');
        this.animationTrigger = mainContentChildren[parentElementIndex + 1];

        if(Shopify.designMode == true) return; // Shopify Editor breaks when GSAP is enabled while editing.
        history.scrollRestoration = "manual";

        this.tlConfig = {
          trigger: this.animationTrigger,
          start: `-${gsap.getProperty('html', '--header-height')} top`,
          scrub: true,
          pin: true,
          anticipatePin: 1,
        }

        iconNext.addEventListener('click', this.moveToNextSection.bind(this));

        this.waitForGsapReady();
      }

      moveToNextSection(evt) {
       window.scrollTo({
        top: gsap.getProperty(this, '--transition-length'),
        behavior: "smooth",
       })
      }

      waitForGsapReady() {
        this.waitInterval = setInterval(() => {
          if(window.gsap) {
            clearInterval(this.waitInterval);
            this.init();
          }
        }
        , 500)
      }

      init() {
        this.mm = gsap.matchMedia();

        this.mm.add('(min-width: 993px)', () => {
          let tl = gsap.timeline({
            scrollTrigger: {
              ...this.tlConfig,
              end: `+=${gsap.getProperty(this, '--transition-length')}`
            }
          })

          const config = {
            top: gsap.getProperty(this, '--shape-top'),
            bottom: gsap.getProperty(this, '--shape-bottom'),
            sides: gsap.getProperty(this, '--shape-sides')
          }

          tl.to(config, {
            top: 0,
            bottom: 0,
            sides: 0,
            ease: "power1.in",
            onUpdate: () => {
              this.style.setProperty('--current-shape-top', config.top + 'px');
              this.style.setProperty('--current-shape-bottom', config.bottom + 'px');
              this.style.setProperty('--current-shape-sides', config.sides + 'px');
            }
          })

          tl.to(this, {
            opacity: 0,
            duration: 0.2,
            ease: "power1.in",
          },">-0.2")

          tl.to(this, {
            pointerEvents: 'none'
          }, ">0")

          return () => tl.kill();
        })

        this.mm.add('(max-width: 992px)', () => {
           let tl = gsap.timeline({
            scrollTrigger: {
              ...this.tlConfig,
              end: `+=${gsap.getProperty(this, '--transition-length')}`
            }
          })

          const config = {
            top: gsap.getProperty(this, '--mobile-shape-top'),
            bottom: gsap.getProperty(this, '--mobile-shape-bottom'),
            sides: gsap.getProperty(this, '--mobile-shape-sides')
          }

          tl.to(config, {
            top: 0,
            bottom: 0,
            sides: 0,
            ease: "power1.in",
            onUpdate: () => {
              this.style.setProperty('--current-shape-top', config.top + 'px');
              this.style.setProperty('--current-shape-bottom', config.bottom + 'px');
              this.style.setProperty('--current-shape-sides', config.sides + 'px');
            }
          })

          tl.to(this, {
            opacity: 0,
            duration: 0.2,
            ease: "power1.in",
          },">-0.2")

          tl.to(this, {
            pointerEvents: 'none'
          }, ">0")

          return () => tl.kill();
        })
      }

      disconnectedCallback() {
        this.abortController.abort();
        if(Shopify.designMode == false) {
          this.mm.revert();
        }
      }
    }

    customElements.define('overlaying-mask', OverlayingMask);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('quick-view')) {
    class QuickView extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.section = this.closest('.shopify-section')
        this.abortController = new AbortController();
        this.modalWindow = this.querySelector('modal-window');
        this.modalInner = this.querySelector('.modal-window__inner');
        this.scrollPosition = 0;
        this.testButton = this.querySelector('[data-ui-toggle]');

        document.addEventListener('quick-view:open-modal', this.openModal.bind(this), {
          signal: this.abortController.signal
        });

        this.addEventListener('pdp:product-change', (evt) => evt.stopPropagation(), {
          signal: this.abortController.signal
        })

        this.addEventListener('pdp:variant-change', (evt) => evt.stopPropagation(), {
          signal: this.abortController.signal
        })

        this.modalInner.addEventListener('scroll', this.onDrawerScroll.bind(this), {
          signal: this.abortController.signal,
          passive: true
        })

        this.modalInner.addEventListener('submit', this.onFormSubmit.bind(this), {
          signal: this.abortController.signal
        })

        if(this.testButton) {
          this.testButton.addEventListener('click', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();

            document.querySelectorAll('.product-card__quick-view-button').forEach(button => button.classList.toggle('visible'));
          }, {
            signal: this.abortController.signal
          })
        }

        document.addEventListener('shopify:section:select', this.onSectionSelect.bind(this), {signal: this.abortController.signal});
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect.bind(this), {signal: this.abortController.signal});
      }

      async onSectionSelect(evt) {
        const sectionId = evt.detail.sectionId;
        if(this.section.id.replace('shopify-section-', '') == sectionId) {
          this.openModal({
            detail: {
              productUrl: this.dataset.referenceProduct
            }
          })
        }
      }

      async updateModalContent(productUrl) {
        const promise = new Promise((resolve, reject) => {
          try {
            fetch(productUrl + '?view=quick_view')
            .then(resp => resp.text())
            .then((html) => {
              const parser = new DOMParser();

              const doc = parser.parseFromString(html, "text/html");

              this.querySelector('.modal-window__body').innerHTML = doc.querySelector('.modal-window__body').innerHTML;

              resolve();
            })
          } catch (error) {
            promise.reject(error);
          }
        });

        return await promise;
      }

      onSectionDeselect(evt) {
        const sectionId = evt.detail.sectionId;
        if(this.section.id.replace('shopify-section-', '') == sectionId) {
          this.modalWindow.closeModal();
        }
      }

      async openModal(evt) {
        this.referrer = evt.detail.referrer;
        this.recId = evt.detail.recId;
        const productUrl = evt.detail.productUrl;

        if(this.referrer) {
          this.referrer.innerText = evt.detail.referrerText;
        }

        if(productUrl) {
          await this.updateModalContent(productUrl);
        }

        if(evt.detail.body) {
          this.querySelector('.modal-window__body').innerHTML = evt.detail.body.innerHTML;
        }

        if(!productUrl && !evt.detail.body) return;

        this.infoContainer = this.querySelector('.quick-view__product-blocks');
        this.modalWindow.openModal();
        if(evt.detail.color) {
          this.changeColor(evt.detail.color);
        }
        this.querySelector('.modal-window__inner').scrollTo({
          top: 0
        })
      }

      changeColor(color) {
        this.querySelector(`input[value="${color}"]`).click();
      }

      onDrawerScroll(evt) {
        const scrollDirection = this.modalInner.scrollTop < this.scrollPosition ? 'up' : 'down';
        this.scrollPosition = this.modalInner.scrollTop;

        if(this.scrollDirection == scrollDirection) return;

        const fillerHeight = this.infoContainer.offsetTop;
        const contentHeight = this.infoContainer.offsetHeight;
        const drawerHeight = this.modalInner.offsetHeight;
        const contentDifference = contentHeight - drawerHeight;

        this.modalInner.style.setProperty('--filler-height', fillerHeight + 'px');
        this.modalInner.style.setProperty('--offset-height', contentDifference + 'px');

        if(!evt) {
          this.modalInner.classList.add('scroll-direction--down');
          return;
        }

        if(scrollDirection == 'up') {
          this.modalInner.classList.add('scroll-direction--up');
          this.modalInner.classList.remove('scroll-direction--down');
        } else {
          this.modalInner.classList.add('scroll-direction--down');
          this.modalInner.classList.remove('scroll-direction--up');
        }

        this.scrollDirection = scrollDirection;
      }

      onFormSubmit(evt) {
        evt.stopPropagation();

        this.modalWindow.closeModal();
        const referrerLabel = this.referrer.innerText;

        this.referrer.innerText = 'Added';
        this.referrer.classList.add('product-card__quick-view-button--added');
        this.referrer.focus();

        if(this.recId) {
          const productId = evt.srcElement.querySelector('[name="id"]').value
          nostojs(api => {
            api.recommendedProductaddedToCart(productId, this.recId);
          })
        }

        setTimeout(() => {
          this.referrer.innerText = referrerLabel;
          this.referrer.classList.remove('product-card__quick-view-button--added')
        },3000)

      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('quick-view', QuickView);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-home-3-column"] && !Shopify.designMode) return;
  try {
    
try {
  const intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if(entry.target.tagName = 'VIDEO') {
        if(entry.isIntersecting) {
          entry.target.play()
        } else {
          entry.target.pause();
        }
      }
    })
  }, {
    rootMargin: "300px",
    threshold: [0, 0.01, 0.1]
  });

  const sectionVideos = document.querySelectorAll('.v2-home-3-column video');

  sectionVideos.forEach((video) => {
    intersectionObserver.observe(video);
  })
} catch (error) {
  console.error('[v2-home-3-columns] error:', error);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-home-video"] && !Shopify.designMode) return;
  try {
    
  class ComponentHero extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.abortController = new AbortController();
      this.resizeChange = window.matchMedia('(max-width: 768px)');
      this.video = this.querySelector('video');

      this.resizeChange.addEventListener('change', () => {
        this.video.load()
      }, {
        signal: this.abortController.signal
      })
    }

    disconnectedCallback() {
      this.abortController.abort();
    }
  }

  customElements.define('component-hero', ComponentHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-nosto-category-recs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nosto-tabs')) {
    customElements.define(
      'nosto-tabs',
      class nostoTabs extends HTMLElement {
        constructor() {
          super();
          this.sliders = [];
        }

        connectedCallback() {
          this.abortController = new AbortController();
          this.tabs = this.querySelectorAll('.tab-list a');
          this.activeTab = this.querySelector('.tab-list a.active').getAttribute('data-tab');
          this.allSelectors = Array.from(this.querySelectorAll('[data-tab]'));
          this.collectionQuery = this.querySelectorAll('.collection-tab');

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', this.onTabClick.bind(this), {
              signal: this.abortController.signal,
            });
          });

          this.loadCollections();
        }

        onTabClick(evt) {
          evt.preventDefault();
          const tabRef = evt.target.dataset.tab;
          this.allSelectors.forEach((tab) => {
            if (tab.dataset.tab == tabRef) {
              tab.classList.add('active');
            } else {
              tab.classList.remove('active');
            }
          });
        }

        loadCollections() {
          this.collectionQuery.forEach((col, index) => {
            const collectionId = col.dataset.collectionId;
            const apiOptions = {
              products: {
                facets: ['*'],
                fields: ['url'],
                size: 12,
                from: 0,
                categoryId: collectionId,
              },
            };

            nostojs((api) => {
              api
                .search(apiOptions, {
                  redirect: false,
                })
                .then((response) => {
                  const products = response.products.hits.map((product) => {
                    return `
                <li><v3-product-card data-url="${product.url}" class="skeleton-item" data-hide-swatches="true"></v3-product-card></li>
              `;
                  });
                  const sliderHTML = `
              <ul
                data-nosto="false"
                data-id="collection-tab--${collectionId}"
                data-title="">
                ${products.join('')}
              </ul>
            `;

                  col.innerHTML = sliderHTML;

                  if (index == 0) {
                    col.parentElement.classList.add('active');
                    this.querySelector('.nosto-category-recs-skeleton').remove();
                  }

                  this.initSlider(col.querySelector('ul'));
                });
            });
          });
        }

        initSlider(container) {
          const slider = new tns({
            autoWidth: false,
            items: 4,
            gutter: 25,
            slideBy: 4,
            mouseDrag: true,
            swipeAngle: false,
            container: container,
            speed: 400,
            edgePadding: 150,
            loop: false,
            responsive: {
              1200: {
                items: 4,
                edgePadding: 100,
                slideBy: 4,
              },
              850: {
                items: 3,
                edgePadding: 50,
                slideBy: 3,
              },
              768: {
                items: 3,
                edgePadding: 50,
                slideBy: 3,
              },
              500: {
                items: 2,
                edgePadding: 50,
                gutter: 15,
                slideBy: 2,
              },
              100: {
                items: 2,
                edgePadding: 30,
                gutter: 15,
                slideBy: 2,
              },
            },
          });

          this.sliders.push(slider);
        }

        disconnectedCallback() {
          this.abortController.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-tabbed-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabbed-categories')) {
    class TabbedCategories extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.tabs = this.querySelectorAll('.cat-tabs li');
        this.activeTab = this.querySelector('.cat-tabs li.active').getAttribute('data-tab');
        this.allSelectors = this.querySelectorAll('[data-tab]');
        this.sliders = this.querySelectorAll('[data-slider]');
        this.tabs.forEach((tab) => {
          tab.addEventListener(
            'click',
            function () {
              tab.classList.add('active');
              this.activeTab = tab.getAttribute('data-tab');
              this.updateTabs();
            }.bind(this)
          );
        });
        this.createSliders();
      }
      updateTabs() {
        this.allSelectors.forEach((tab) => {
          if (tab.getAttribute('data-tab') == this.activeTab) {
            tab.classList.add('active');
          } else {
            tab.classList.remove('active');
          }
        });
      }
      createSliders() {
        if(tns) {
          this.sliders.forEach((slider) => {
            var sSelector = slider.getAttribute('data-slider');
            var slider = tns({
              autoWidth: false,
              items: 1,
              gutter: 15,
              slideBy: 1,
              mouseDrag: true,
              swipeAngle: false,
              container: sSelector,
              speed: 800,
              edgePadding: 30,
              loop: false,
              autoplay: false,
              responsive: {
                768: {
                  items: 4,
                  edgePadding: 0,
                  slideBy: 4,
                  gutter: 20,
                },
              },
            });
          });
        } else {
          setTimeout(() => {
            this.createSliders();
          }, 300);
        }
      }
    }

    customElements.define('tabbed-categories', TabbedCategories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-timer')) {
    customElements.define(
      'countdown-timer',
      class CountdownTimer extends HTMLElement {
        constructor() {
          super();
          this.countContainer = this.querySelector('[data-countdown-container]');
          this.mini = this.getAttribute('data-mini') === 'true';
          this.end = new Date(
            `${this.getDateInfo('year')}-${this.getDateInfo('month')}-${this.getDateInfo('day')}T${this.getDateInfo(
              'hours'
            )}:${this.getDateInfo('minutes')}:${this.getDateInfo('seconds')}.000-08:00`
          );
          this.startCountdown();
        }
        changeTimezone(date, ianatz) {
          const invdate = new Date(
            date.toLocaleString('en-US', {
              timeZone: ianatz,
            })
          );
          const diff = date.getTime() - invdate.getTime();
          return new Date(date.getTime() - diff);
        }
        getDateInfo(attribute) {
          const attr = this.getAttribute(`data-${attribute}`);
          if (attr) {
            return parseInt(attr) < 10 ? `0${parseInt(attr)}` : parseInt(attr);
          } else {
            return 0;
          }
        }
        startCountdown() {
          const container = this.countContainer;
          const end = this.end;
          const changeTimezone = this.changeTimezone;
          const isMini = this.mini;
          const x = setInterval(function () {
            const current = changeTimezone(new Date(), Intl.DateTimeFormat().resolvedOptions().timeZone);
            const distance = end - current;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            if (hours < 10) {
              hours = '0' + hours;
            }
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            if (minutes < 10) {
              minutes = '0' + minutes;
            }
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if (seconds < 10) {
              seconds = '0' + seconds;
            }
            let copy = `<span class='u-c'>${days}<span class='label'>${isMini ? 'd' : 'DAY(S)'}</span></span>:`;
            copy += `<span class='u-c'>${hours}<span class='label'>${isMini ? 'h' : 'HOUR(S)'}</span></span>:`;
            copy += `<span class='u-c'>${minutes}<span class='label'>${isMini ? 'm' : 'MINUTE(S)'}</span></span>:`;
            copy += `<span class='u-c'>${seconds}<span class='label'>${isMini ? 's' : 'SECOND(S)'}</span></span>`;
            container.innerHTML = copy;
            if (distance < 0) {
              clearInterval(x);
              container.innerHTML = isMini ? '' : 'EXPIRED';
            }
          }, 1000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-main-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('main-product')) {
  class MainProduct extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.abortController = new AbortController();
      this.infoContainer = this.querySelector('.product__info-block-inner');
      this.stickyHeader = document.querySelector('sticky-header');

      const header = document.querySelector('sticky-header');

      document.querySelector('body').style.setProperty('--header-height', header.offsetHeight + "px");

      this.resizeObserver = new ResizeObserver(this.observerCallback.bind(this));
      window.addEventListener('scroll', this.updateScrollDirection.bind(this), {
        passive: true,
        signal: this.abortController.signal
      })

      this.resizeObserver.observe(this.infoContainer);

      this.updateScrollDirection();
    }

    observerCallback(entries) {
      const headerCompensation = this.scrollDirection == 'up' ? this.stickyHeader.offsetHeight : 0;
      let heightDifference = (this.infoContainer.offsetHeight - window.innerHeight + headerCompensation);

      if(heightDifference < 0) {
        if(this.scrollDirection == 'down') {
          heightDifference = -this.stickyHeader.offsetHeight;
        } else {
          heightDifference = this.infoContainer.offsetHeight - window.innerHeight + this.stickyHeader.offsetHeight
        }
      }

      this.style.setProperty('--heightDifference', heightDifference + "px");
    }

    updateScrollDirection() {
      const currentDirection = this.scrollPosition > window.scrollY ? 'up' : 'down';
      const headerCompensation = currentDirection == 'up' ? this.stickyHeader.offsetHeight : 0;
      let heightDifference = (this.infoContainer.offsetHeight - window.innerHeight + headerCompensation);

      if(heightDifference < 0) {
        if(currentDirection == 'down') {
          heightDifference = -this.stickyHeader.offsetHeight;
        } else {
          heightDifference = this.infoContainer.offsetHeight - window.innerHeight + this.stickyHeader.offsetHeight
        }
      }

      this.scrollPosition = window.scrollY;

      // Prevent reexecutions while keeping the same direction
      if(this.scrollDirection == currentDirection) return;
      this.scrollDirection = currentDirection;
      this.style.setProperty('--fillerHeight', (this.infoContainer.offsetTop - this.infoContainer.parentElement.offsetTop) + 'px');
      this.style.setProperty('--heightDifference', heightDifference + "px");

      if(currentDirection == 'down') {
        this.infoContainer.classList.add('product__info-container--down');
        this.infoContainer.classList.remove('product__info-container--up');
      }

      if(currentDirection == 'up') {
        this.infoContainer.classList.add('product__info-container--up');
        this.infoContainer.classList.remove('product__info-container--down');
      }
    }

    disconnectedCallback() {
      this.abortController.abort();
    }
  }

  customElements.define('main-product', MainProduct);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-nosto-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-grid')) {
    class CollectionGrid extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.categoryId = this.dataset.collection;
        this.collectionSize = this.dataset.collectionSize;
        this.gridContainer = this.querySelector('[data-product-grid]');
        this.loadMoreBtn = this.querySelector('[data-load-more]');
        this.itemsCount = this.querySelector('[data-items-count]');
        this.itemsTotal = this.querySelector('[data-items-total]');

        this.collectionArray = [];

        this.getCollectionData({
          collection_from: 0,
        });

        this.loadMoreBtn.addEventListener('click', () => {
          const page = this.loadMoreBtn.dataset.page;

          this.getCollectionData({ collection_from: this.collectionSize * parseInt(page - 1) });
        });
      }

      async getCollectionData({ collection_from = 0 }) {
        await nostojs((api) => {
          api
            .search({
              products: {
                facets: ['*'],
                fields: [
                  'name',
                  'price',
                  'listPrice',
                  'url',
                  'imageUrl',
                  'alternateImageUrls',
                  'customFields.key',
                  'customFields.value',
                  'categories',
                  'tags1',
                ],
                size: parseInt(this.collectionSize),
                from: collection_from,
                categoryId: this.categoryId,
              },
              track: 'collection',
              redirect: true
            })
            .then((response) => {
              let products = response.products.hits;
              let sIndex = collection_from;
              let currentPage = collection_from / parseInt(this.collectionSize);
              let metafields = [];

              products = products.map((nostoItem, index) => {
                sIndex += 1;

                nostoItem.page = currentPage;
                nostoItem.sIndex = sIndex;
                nostoItem.cardPosition = `P${currentPage}C${sIndex}`;
                nostoItem.videoDesktop = null;
                nostoItem.videoMobile = null;
                nostoItem.videoUnisex = null;
                nostoItem.videoUnisex_womens_image_position = null;
                nostoItem.videoUnisex_mens_image_position = null;
                nostoItem.videoUnisex_mens_plp_desktop_video = null;
                nostoItem.videoUnisex_mens_plp_mobile_video = null;

                nostoItem.customFields.forEach((field, i) => {
                  if (field.key == 'images-image_icon') {
                    metafields.push(field);
                  }
                  if (field.key == 'video-plp_desktop_video') {
                    let video = JSON.parse(field.value);
                    nostoItem.videoDesktop = video[0].src;
                  }
                  if (field.key == 'video-plp_mobile_video') {
                    let video = JSON.parse(field.value);
                    nostoItem.videoMobile = video[0].src;
                  }
                  if (field.key == 'video-unisex') {
                    nostoItem.videoUnisex = field.value;
                  }
                  if (field.key == 'video-unisex_womens_image_position') {
                    nostoItem.videoUnisex_womens_image_position = parseInt(field.value);
                  }
                  if (field.key == 'video-unisex_womens_hover_image_position') {
                    nostoItem.videoUnisex_womens_hover_image_position = parseInt(field.value);
                  }
                  if (field.key == 'video-unisex_mens_image_position') {
                    nostoItem.videoUnisex_mens_image_position = parseInt(field.value);
                  }
                  if (field.key == 'video-unisex_mens_hover_image_position') {
                    nostoItem.videoUnisex_mens_hover_image_position = parseInt(field.value);
                  }
                  if (field.key == 'video-unisex_mens_plp_dekstop_video') {
                    let video = JSON.parse(field.value);
                    nostoItem.videoUnisex_mens_plp_desktop_video = video[0].src;
                  }
                  if (field.key == 'video-unisex_mens_plp_mobile_video') {
                    let video = JSON.parse(field.value);
                    nostoItem.videoUnisex_mens_plp_mobile_video = video[0].src;
                  }
                });

                nostoItem.metafields = metafields;
                delete nostoItem.customFields;

                if (document.location.pathname.indexOf('/collections/') > -1) {
                  nostoItem.url = nostoItem.url.replace('/products', document.location.pathname + '/products');
                }

                let categories = nostoItem.categories?.map((category) => category.toLowerCase());
                let collectionTitle = '';
                let collectionHandle = '';
                categories?.forEach((category) => {
                  if (category.startsWith('collection - ')) {
                    collectionTitle = category;
                  }
                });

                if (collectionTitle != '') {
                  collectionHandle = collectionTitle.replaceAll(/\W/gm, '-').replaceAll(/-+/gm, '-');
                  if (this.collectionArray.indexOf(collectionHandle) === -1) {
                    this.collectionArray.push(collectionHandle);
                  }
                }
                return nostoItem;
              });

              if (collection_from == 0) {
                this.gridContainer.innerHTML = '';
              }

              this.buildProducts({
                products,
              });

              this.buildLoadButtons({ info: response.products });
            });
        });
      }

      buildProducts({ products }) {
        products.forEach((product, index) => {
          let genderedMainImageIndex = false;
          let genderedHoverImageIndex = false;

          this.gridContainer.insertAdjacentHTML(
            'beforeend',
            `
          <li class="collection-grid__product" data-slot="${product.sIndex}">
            <v3-product-card
              data-url="${product.url}"
              data-product-id="${product.productId}",
              id="${product.cardPosition}"
              class="skeleton-item"
              data-video-desktop="${product.videoDesktop}"
              data-video-mobile="${product.videoMobile}"
              ${index < 4 ? 'data-loading="eager"' : ''}
            >
            </v3-product-card>
          </li>
        `
          );
        });
      }

      buildLoadButtons({ info }) {
        const currentPage = info.from / info.size + 1;
        const maxPage = Math.ceil(info.total / info.size);
        const previousPagesCount = (currentPage - 1) * info.size;
        const childrenCount = previousPagesCount + info.hits.length;

        this.itemsCount.innerText = childrenCount;
        this.itemsTotal.innerText = info.total;

        // Update load more button
        if (currentPage != maxPage) {
          this.loadMoreBtn.setAttribute('data-page', currentPage + 1);
          this.loadMoreBtn.removeAttribute('style');
        } else {
          this.loadMoreBtn.style.display = 'none';
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
    customElements.define('collection-grid', CollectionGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-nosto-collection"]) return;
  try {
    
  if (!customElements.get('v3-nosto-collection')) {
    class V3NostoCollection extends HTMLElement {
      constructor() {
        super();

        this.abortController;
        this.search = this.dataset.search;
        this.collectionSize = 24;
        this.collectionArray = [];
        this.exposedFilters = this.getAttribute('exposed-filters').split(', ');
        this.hiddenFilters = this.getAttribute('hidden-filters').split(', ');
        this.openFilters = JSON.parse(this.dataset.openFilters) || [];
        this.swatchFilters = JSON.parse(this.dataset.swatchFilters) || [];
        this.filterOrder = this.dataset.filterOrder ? JSON.parse(this.dataset.filterOrder) : null;
        this.enableInfiniteScrolling = this.dataset.infniteScrolling == 'true';
        //Product Grid
        this.productGrid = this.querySelector('[data-collection-grid]');

        //Filters Bar
        this.gridSizeSelector = this.querySelectorAll('input[name="layout-selection"]');
        this.initialGridSize = localStorage.getItem('CollectionGridSize');
        this.activeFiltersContainer = this.querySelector('[data-active-filters');

        //Filters
        this.sortSelects = this.querySelectorAll('[data-sort-options]');
        this.filtersContainer = this.querySelector('[data-filters-container]');
        this.filtersList = this.querySelector('[data-collection-filters]');
        this.filtersTemplate = this.filtersContainer.querySelector('template').content.cloneNode(true);
        this.desktopFilterToggleBtn = this.querySelector('[data-desktop-toggle-filter]');
        this.mobileFilterToggleBtn = this.querySelector('[data-mobile-toggle-filter]');
        this.mobileFilterClear = this.filtersContainer.querySelector('[data-clear-all]');
        this.mobileCloseFilters = this.filtersContainer.querySelectorAll('[data-close-filters]');
        this.visualFilters = this.querySelector('#nosto-visual-filters');

        // Pagination
        this.loadMoreBtn = this.querySelector('[data-load-more][data-direction="after"]');
        this.loadPreviousBtn = this.querySelector('[data-load-more][data-direction="before"]');
        this.itemsCount = this.querySelector('[data-items-count]');
        this.itemsTotal = this.querySelector('[data-items-total]');
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.intersectionObserver = new IntersectionObserver(this.loadPreviousHandler.bind(this), {
          rootMargin: '900px',
          threshold: 0,
        });

        this.slotsPositions = this.dataset.slotPositions == '' ? null : JSON.parse(this.dataset.slotPositions);
        this.slotsIds = this.dataset.slotIds == '' ? null : JSON.parse(this.dataset.slotIds);
        this.slotsWidths = this.dataset.slotWidths == '' ? null : JSON.parse(this.dataset.slotWidths);

        this.desktopFilterToggleBtn.addEventListener('click', this.toggleFilterDrawerDesktop.bind(this), {
          signal: this.abortController.signal,
        });

        this.gridSizeSelector.forEach((selector) => {
          selector.addEventListener('change', this.onGridSizeSelectorChange.bind(this), {
            signal: this.abortController.signal,
          });
        });

        this.sortSelects.forEach((select) => {
          select.addEventListener('change', this.onSortChange.bind(this), {
            signal: this.abortController.signal,
          });
        });

        this.productGrid.addEventListener('click', this.onCardClicked.bind(this), {
          signal: this.abortController.signal,
        });

        this.activeFiltersContainer.addEventListener('click', this.onFilterRemoveClick.bind(this), {
          signal: this.abortController.signal,
        });

        this.loadMoreBtn.addEventListener('click', this.onLoadNextClick.bind(this), {
          signal: this.abortController.signal,
        });

        this.loadPreviousBtn.addEventListener('click', this.onLoadPreviousClick.bind(this), {
          signal: this.abortController.signal,
        });

        this.filtersContainer.addEventListener('change', this.onFilterChange.bind(this), {
          signal: this.abortController.signal,
        });

        this.filtersContainer.addEventListener('click', this.onFiltersButtonClick.bind(this), {
          signal: this.abortController.signal,
        });

        this.mobileFilterToggleBtn.addEventListener('click', this.toggleFilterDrawerMobile.bind(this), {
          signal: this.abortController.signal,
        });

        this.mobileCloseFilters.forEach((button) => {
          button.addEventListener('click', this.toggleFilterDrawerMobile.bind(this), {
            signal: this.abortController.signal,
          });
        });

        if (this.visualFilters) {
          const visualFilter = this.visualFilters.querySelectorAll('.visual-filter');
          if(visualFilter.length > 0) {
            visualFilter.forEach(filter => {
              filter.addEventListener('mouseenter', this.onVisualFilterEnter.bind(this), {
                signal: this.abortController.signal,
              });
              filter.addEventListener('mosueleave', this.onVisualFilterLeave.bind(this), {
                signal: this.abortController.signal,
              });
            })
          }

          this.visualFilters.addEventListener('change', this.onVisualFilterClick.bind(this), {
            signal: this.abortController.signal,
          });

        }

        this.gendered = this.dataset.gendered;

        this.setGridSize(this.initialGridSize || 'small');

        const urlObject = new URL(document.location.href);
        const page = urlObject.searchParams.get('page');

        this.getCollectionData({
          collection_reset: true,
          collection_from: Math.max(this.collectionSize * page - this.collectionSize, 0),
        });

        window.addEventListener('pageshow', (evt) => {
          if(evt.persisted) {
            this.checkLocationHash();
          }
        }, {
          signal: this.abortController.signal
        })

        history.scrollRestoration = 'manual';
      }

      onGridSizeSelectorChange(evt) {
        this.setGridSize(evt.target.value);
      }

      setGridSize(gridSize) {
        const currentSelector = Array.from(this.gridSizeSelector).find((el) => {
          return el.value == gridSize;
        });
        currentSelector.checked = true;
        localStorage.setItem('CollectionGridSize', gridSize);

        if (gridSize == 'small') {
          this.classList.add('collection--small');
          this.classList.remove('collection--large');
        } else {
          this.classList.add('collection--large');
          this.classList.remove('collection--small');
        }
      }

      async getCollectionData({
        collection_from = 0,
        collection_reset = false,
        collection_size = this.collectionSize,
        collection_direction = null,
      } = {}) {
        let urlObject = new URL(document.location.href);

        const filters = urlObject.searchParams.getAll('f');
        const sort = urlObject.searchParams.get('sort');
        let structuredFilters = {};
        let requestFilters = [];

        filters.forEach((filter) => {
          const filterParts = filter.split(':');
          if (structuredFilters[filterParts[0]]) {
            structuredFilters[filterParts[0]] += `, ${filterParts[1]}`;
          } else {
            structuredFilters[filterParts[0]] = filterParts[1];
          }
        });

        Object.keys(structuredFilters).forEach((key) => {
          requestFilters.push({
            field: key,
            value: structuredFilters[key].split(', '),
          });
        });

        let apiOptions = {};

        // @todo validate loadprevious working 50%

        apiOptions.products = {
          facets: ['*'],
          currencyFormat: window._currency,
          fields: [
            'name',
            'price',
            'listPrice',
            'url',
            'imageUrl',
            'alternateImageUrls',
            'customFields.key',
            'customFields.value',
            'categories',
            'tags1',
          ],
          filter: requestFilters,
          size: collection_size,
          from: collection_from,
        };
        this.trackType = 'category';

        if (this.search != '') {
          apiOptions.query = this.search;
          this.trackType = 'serp';
        } else {
          apiOptions.products.categoryId = this.dataset.collection;
        }

        const trackType = this.trackType;

        if (sort) {
          const sortParts = sort.split(':');
          apiOptions.products.sort = {
            field: sortParts[0],
            order: sortParts[1],
          };
        }

        await nostojs((api) => {
          api
            .search(apiOptions, {
              track: trackType,
              redirect: true,
            })
            .then((response) => {
              let products = response.products.hits;

              if (collection_direction == 'before') {
                products.reverse();
              }

              let container = this.querySelector('[data-collection-grid]');

              if (collection_reset) {
                container.innerHTML = '';
              }

              let metafields = [];
              let currentPage = Math.ceil((products.length + response.products.from) / collection_size);

              let sIndex =
                collection_direction == 'before' ? collection_from + response.products.hits.length : collection_from;

              products = products.map((nostoItem, index) => {
                if (collection_direction == 'before') {
                  if (index > 0) {
                    sIndex -= 1;
                  }
                } else {
                  sIndex += 1;
                }

                nostoItem.page = currentPage;
                nostoItem.sIndex = sIndex;
                nostoItem.cardPosition = `P${currentPage}C${sIndex}`;
                nostoItem.videoDesktop = null;
                nostoItem.videoMobile = null;
                nostoItem.videoUnisex = null;
                nostoItem.videoUnisex_womens_image_position = null;
                nostoItem.videoUnisex_mens_image_position = null;
                nostoItem.videoUnisex_mens_plp_desktop_video = null;
                nostoItem.videoUnisex_mens_plp_mobile_video = null;

                nostoItem.customFields.forEach((field, i) => {
                  if (field.key == 'images-image_icon') {
                    metafields.push(field);
                  }
                  if (field.key == 'video-plp_desktop_video') {
                    let video = JSON.parse(field.value);
                    nostoItem.videoDesktop = video[0].src;
                  }
                  if (field.key == 'video-plp_mobile_video') {
                    let video = JSON.parse(field.value);
                    nostoItem.videoMobile = video[0].src;
                  }
                  if (field.key == 'video-unisex') {
                    nostoItem.videoUnisex = field.value;
                  }
                  if (field.key == 'video-unisex_womens_image_position') {
                    nostoItem.videoUnisex_womens_image_position = parseInt(field.value);
                  }
                  if (field.key == 'video-unisex_womens_hover_image_position') {
                    nostoItem.videoUnisex_womens_hover_image_position = parseInt(field.value);
                  }
                  if (field.key == 'video-unisex_mens_image_position') {
                    nostoItem.videoUnisex_mens_image_position = parseInt(field.value);
                  }
                  if (field.key == 'video-unisex_mens_hover_image_position') {
                    nostoItem.videoUnisex_mens_hover_image_position = parseInt(field.value);
                  }
                  if (field.key == 'video-unisex_mens_plp_dekstop_video') {
                    let video = JSON.parse(field.value);
                    nostoItem.videoUnisex_mens_plp_desktop_video = video[0].src;
                  }
                  if (field.key == 'video-unisex_mens_plp_mobile_video') {
                    let video = JSON.parse(field.value);
                    nostoItem.videoUnisex_mens_plp_mobile_video = video[0].src;
                  }
                });

                nostoItem.metafields = metafields;
                delete nostoItem.customFields;

                if (document.location.pathname.indexOf('/collections/') > -1) {
                  nostoItem.url = nostoItem.url.replace('/products', document.location.pathname + '/products');
                }

                let categories = nostoItem.categories?.map((category) => category.toLowerCase());
                let collectionTitle = '';
                let collectionHandle = '';
                categories?.forEach((category) => {
                  if (category.startsWith('collection - ')) {
                    collectionTitle = category;
                  }
                });

                if (collectionTitle != '') {
                  collectionHandle = collectionTitle.replaceAll(/\W/gm, '-').replaceAll(/-+/gm, '-');
                  if (this.collectionArray.indexOf(collectionHandle) === -1) {
                    this.collectionArray.push(collectionHandle);
                  }
                }
                return nostoItem;
              });

              this.buildProducts({
                products,
                direction: collection_direction,
              });

              this.buildPromoSlots.call(this);

              this.buildFilters({ filters: response.products.facets });

              this.buildLoadButtons({
                info: response.products,
                direction: collection_direction,
              });

              this.updateSortSelectors(sort);

              if (collection_direction == 'before') {
                this.fixScrollPosition();
              }
              
              this.checkLocationHash();
            });
        });
      }

      checkLocationHash() {
        const hash = document.location.hash;

        if (!hash) return;
        const card = this.productGrid.querySelector(hash);
        if (card) {
          setTimeout(() => {
            card.scrollIntoView({
              block: 'center',
            });
          }, 10);

          const url = new URL(document.location.href);
          url.hash = '';

          history.replaceState('', null, url.toString());
        }
      }

      buildFilters({ filters = [] } = {}) {
        const allowedFacets = ['Category', 'Size', 'Color', 'Fit', ...this.exposedFilters];
        const activeFilters = [];

        this.filtersList.innerHTML = '';

        filters.forEach((filter) => {
          if (!allowedFacets.includes(filter.name)) return;
          const isSwatchFilter = this.swatchFilters.includes(filter.name);
          const filterEl = this.filtersTemplate.cloneNode(true);
          const filterGroup = filterEl.querySelector('.filter__group');
          filterGroup.setAttribute('data-name', filter.name);

          if (this.hiddenFilters.includes(filter.name)) {
            filterGroup.style.display = 'none';
          }

          if (this.openFilters.includes(filter.name)) {
            filterGroup.setAttribute('open', 'true');
          }

          filterEl.querySelector('[data-filter-group-title]').innerText = filter.name;
          const filterListContainer = filterEl.querySelector('[data-filter-option-list]');
          let sortedFilters = filter.data;

          if (this.filterOrder != null && this.filterOrder[filter.name]) {
            sortedFilters = this.sortFilterValues(filter.data, this.filterOrder[filter.name]);
          }

          filter.data.forEach((filterObject) => {
            if (filterObject.value.indexOf('||') > -1) {
              return;
            }

            if (filterObject.selected) {
              activeFilters.push({
                category: filter.name,
                field: filter.field,
                value: filterObject.value,
              });
            }

            if (this.visualFilters) {
              const visualFilter = this.visualFilters.querySelector(
                `[data-category="${filter.name}"][value="${filterObject.value}"]`
              );
              if (visualFilter) {
                if (filterObject.selected) {
                  visualFilter.checked = true;
                } else {
                  visualFilter.checked = false;
                }
              }
            }

            const filterItem = document.createElement('li');
            filterItem.innerHTML = `
            <label>
              <input type="checkbox"
                name="${filter.field}"
                value="${filterObject.value}"
                data-category="${filter.name}"
                class="${isSwatchFilter ? 'filter__checkbox-hidden' : ''}"
                ${filterObject.selected ? 'checked="true"' : ''}>
              ${
                isSwatchFilter
                  ? `
                <img class="filter__swatch" src="//www.outerknown.com/cdn/shop/files/${filterObject.value.replaceAll(
                  ' ',
                  '-'
                )}_swatch.jpg" loading="lazy" width="20" height="20" alt="" />
              `
                  : ''
              }
              <span class="filter-label">${filterObject.value}</span>
            </label>
          `;

            filterListContainer.appendChild(filterItem);
          });
          this.filtersList.appendChild(filterEl);
        });

        this.buildActiveFilters(activeFilters);
      }

      sortFilterValues(values, sortmap) {
        return values.sort((a, b) => {
          const a_index = isNaN(a.value) ? sortmap[a.value.toLowerCase()] : sortmap['number'];
          const b_index = isNaN(b.value) ? sortmap[b.value.toLowerCase()] : sortmap['number'];
          if (a_index === undefined) {
            return 1;
          }
          if (b_index === undefined) {
            return -1;
          }

          return a_index - b_index;
        });
      }

      buildActiveFilters(activeFilters) {
        const filterButtons = activeFilters.map((filter) => {
          return `
          <button class="collection__active-filter" data-remove-filter data-filter-name="${filter.field}" data-filter-value="${filter.value}">
            ${filter.category}: ${filter.value}

            <svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.48627 9.32917L2.82849 3.67098" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M2.88539 9.38504L8.42932 3.61524" stroke="#333030" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </button>
        `;
        });

        if (filterButtons.length > 0) {
          filterButtons.push(`
          <button class="collection__active-filter collection__active-filter--clear-all" data-clear-all>
            Clear all
          </button>
        `);
        }

        if (activeFilters.length > 0) {
          this.mobileFilterClear.removeAttribute('hidden');
        } else {
          this.mobileFilterClear.setAttribute('hidden', true);
        }

        this.activeFiltersContainer.innerHTML = filterButtons.join('');
      }

      toggleFilterDrawerMobile() {
        if (this.classList.contains('collection--mobile-open')) {
          this.closeFilter('mobile');
        } else {
          this.openFilter('mobile');
        }
      }

      openFilter(size) {
        if (size == 'desktop') {
          this.classList.add('collection--desktop-open');

          this.desktopFilterToggleBtn.innerText = 'Hide Filters';
          trapFocus(this.filtersContainer, this.filtersContainer, true);
        } else {
          this.classList.add('collection--mobile-open');
          (this.mobileFilterToggleBtn.innerText = 'Hide Filters'),
            trapFocus(this.filtersContainer, this.filtersContainer, true);
        }
      }

      closeFilter(size) {
        if (size == 'desktop') {
          this.classList.remove('collection--desktop-open');

          this.desktopFilterToggleBtn.innerText = 'Show Filters';
          trapFocus(this.filtersContainer, this.filtersContainer, true);
        } else {
          this.classList.remove('collection--mobile-open');
          (this.mobileFilterToggleBtn.innerText = 'Show Filters'),
            trapFocus(this.filtersContainer, this.filtersContainer, true);
        }
      }

      toggleFilterDrawerDesktop() {
        if (this.classList.contains('collection--desktop-open')) {
          this.closeFilter('desktop');
        } else {
          this.openFilter('desktop');
        }
      }

      onFilterChange(evt) {
        const target = evt.target;
        const value = `${target.name}:${target.value}`;

        if (target.type == 'radio') {
          this.onSortChange(evt);

          return;
        }

        if (target.checked == true) {
          this.addFilter(value);
        } else {
          this.removeFilter(value);
        }

        this.getCollectionData({
          collection_from: 0,
          collection_reset: true,
          collection_direction: null,
          collection_size: this.collectionSize,
        });
      }

      onFiltersButtonClick(evt) {
        const target = evt.target;

        if (target.closest('button')) {
          if (target.dataset.closeFilters) {
            this.toggleFilterDrawerDesktop();
          }

          if (target.dataset.clearAll !== undefined) {
            this.clearFilters();
          }
        }

        if (target.tagName == 'SUMMARY') {
          const filterIndex = this.openFilters.findIndex((el) => el == target.parentElement.dataset.name);
          if (target.parentElement.open) {
            if (filterIndex > -1) {
              this.openFilters.splice(filterIndex, 1);
            }
          } else {
            this.openFilters.push(target.parentElement.dataset.name);
          }
        }
      }

      onVisualFilterEnter(evt) {
        const video = evt.target.querySelector('video');

        if(!video) return;

        video.play();
      }

      onVisualFilterLeave(evt) {
        const video = evt.target.querySelector('video');

        if(!video) return;
        setTimeout(() => {
          video.pause();
        }, 250)
      }

      onVisualFilterClick(evt) {
        const category = evt.target.dataset.category;
        const value = evt.target.value;

        this.filtersContainer.querySelector(`[data-category="${category}"][value="${value}"]`).click();
      }

      onFilterRemoveClick(evt) {
        const target = evt.target.closest('button');

        if (target.dataset.clearAll !== undefined) {
          this.clearFilters();
        } else {
          const filterCheckbox = this.filtersContainer.querySelector(
            `input[type="checkbox"][name="${target.dataset.filterName}"][value="${target.dataset.filterValue}"]`
          );

          if (filterCheckbox) {
            filterCheckbox.click();
          }
        }
      }

      addFilter(value) {
        const url = new URL(document.location.href);
        url.searchParams.append('f', value);
        url.searchParams.delete('page');

        history.replaceState('', null, url.toString());
      }

      removeFilter(value) {
        const url = new URL(document.location.href);
        url.searchParams.delete('f', value);
        url.searchParams.delete('page');

        history.replaceState('', null, url.toString());
      }

      clearFilters() {
        const url = new URL(document.location.href);
        url.searchParams.delete('f');
        url.searchParams.delete('page');

        history.replaceState('', null, url);

        this.getCollectionData({
          collection_from: 0,
          collection_reset: true,
          collection_size: this.collectionSize,
        });

        this.closeFilter('mobile');
      }

      buildProducts({ products, direction }) {
        const isOuterworn = document.location.pathname.includes('outerworn');
        const insertPosition = direction == 'before' ? 'afterbegin' : 'beforeend';
        products.forEach((product, index) => {
          let genderedMainImageIndex = false;
          let genderedHoverImageIndex = false;

          if (this.gendered == 'mens') {
            genderedMainImageIndex = product.videoUnisex_mens_image_position;
            genderedHoverImageIndex = product.videoUnisex_mens_hover_image_position;
          } else if (this.gendered == 'womens') {
            genderedMainImageIndex = product.videoUnisex_womens_image_position;
            genderedHoverImageIndex = product.videoUnisex_womens_hover_image_position;
          }
          this.productGrid.insertAdjacentHTML(
            insertPosition,
            `
          <li class="collection-grid__product" data-slot="${product.sIndex}">
            <v3-product-card
              data-url="${product.url}"
              data-product-id="${product.productId}",
              id="${product.cardPosition}"
              class="skeleton-item"
              data-gendered="${this.gendered}"
              data-video-desktop="${product.videoDesktop}"
              data-video-mobile="${product.videoMobile}"
              data-gendered-image-index="${genderedMainImageIndex}"
              data-gendered-hover-image-index="${genderedHoverImageIndex}"
              ${isOuterworn ? `
                data-hide-swatches="true"
                data-hide-quick-view="true"
              ` : ''}
              ${index < 4 ? 'data-loading="eager"' : ''}
            >
            </v3-product-card>
          </li>
        `
          );
        });
      }

      buildPromoSlots() {
        if (!Array.isArray(this.slotsPositions) || !Array.isArray(this.slotsIds) || !Array.isArray(this.slotsWidths))
          return;

        this.slotsPositions.forEach((slotPosition, index) => {
          const populatedSlot = this.productGrid.querySelector(`li[data-promo-slot="${slotPosition}"]`);

          if (!populatedSlot) {
            const adjacentCard = this.productGrid.querySelector(`[data-slot="${slotPosition}"]`);
            if (adjacentCard) {
              adjacentCard.insertAdjacentHTML(
                'beforebegin',
                `
              <li class="collection-grid__promotion collection-grid__promotion--${this.slotsWidths[index]}" data-promo-slot="${slotPosition}">
                <div class="nosto_element" id="${this.slotsIds[index]}"></div>
              </li>
            `
              );
            }
          }
        });

        nostojs((api) => {
          api
            .defaultSession()
            .setResponseMode('HTML')
            .viewFrontPage()
            .setPlacements(api.placements.getPlacements())
            .load()
            .then((response) => {
              api.placements.injectCampaigns(response.recommendations);
            });
        });
      }

      buildLoadButtons({ info, direction }) {
        const currentPage = info.from / info.size + 1;
        const maxPage = Math.ceil(info.total / info.size);
        const previousPagesCount = (currentPage - 1) * info.size;
        const childrenCount = previousPagesCount + info.hits.length;

        // Load pagination information
        if (direction != 'before') {
          this.itemsCount.innerText = childrenCount;
          this.itemsTotal.innerText = info.total;
        }

        if (this.loadPreviousBtn.dataset.observed != true) {
          this.intersectionObserver.observe(this.loadPreviousBtn);
          this.loadPreviousBtn.setAttribute('data-observed', true);
        }

        if(this.loadMoreBtn.dataset.obseved != true) {
          this.intersectionObserver.observe(this.loadMoreBtn);
          this.loadMoreBtn.setAttribute('data-observed', true);
        }

        // Update load previous button
        if (currentPage > 1) {
          this.loadPreviousBtn.setAttribute('data-page', currentPage);
          this.loadPreviousBtn.style.opacity = 1;
        } else {
          this.loadPreviousBtn.parentElement.setAttribute('hidden', true);
          this.intersectionObserver.unobserve(this.loadPreviousBtn);
        }

        // Update load more button
        if (currentPage != maxPage) {
          if (direction != 'before') {
            this.loadMoreBtn.setAttribute('data-page', currentPage + 1);
            this.loadMoreBtn.removeAttribute('style');
          }
        } else {
          this.loadMoreBtn.style.display = 'none';
          this.intersectionObserver.unobserve(this.loadMoreBtn);
        }
      }

      updateSortSelectors(value) {
        const radioSelect = this.filtersContainer.querySelector(`input[type="radio"][value="${value}"`);
        if (radioSelect) {
          this.sortSelects.forEach((el) => {
            el.value = value;
          });
          radioSelect.checked = true;
        }
      }

      onSortChange(evt) {
        const currentStatus = new URL(document.location.href);
        const newSort = evt.target.value;

        this.updateSortSelectors(newSort);

        if (newSort == '') {
          currentStatus.searchParams.delete('sort');
        } else {
          currentStatus.searchParams.set('sort', newSort);
        }

        currentStatus.searchParams.delete('page');

        history.replaceState('', null, currentStatus.toString());

        this.getCollectionData({
          collection_from: 0,
          collection_reset: true,
          collection_size: this.collectionSize,
        });
      }

      onLoadNextClick(evt) {
        const page = evt.target.dataset.page;
        const url = new URL(document.location.href);

        url.searchParams.set('page', page);

        history.replaceState('', null, url.toString());

        this.getCollectionData({
          from: this.collectionSize * page + this.collectionSize,
          collection_reset: false,
          collection_direction: evt.target.dataset.direction,
          collection_size: this.collectionSize,
          collection_from: this.collectionSize * page - this.collectionSize,
        });
      }

      fixScrollPosition() {
        const scrollDiff = this.productGrid.scrollHeight - this.gridHeight;

        window.scrollBy({
          top: scrollDiff,
        });
      }

      onLoadPreviousClick(evt) {
        const page = evt.target.dataset.page;
        const url = new URL(document.location.href);

        url.searchParams.set('page', page);

        history.replaceState('', null, url.toString());

        this.gridHeight = this.productGrid.scrollHeight;

        this.getCollectionData({
          from: this.collectionSize * page + this.collectionSize,
          collection_reset: false,
          collection_direction: evt.target.dataset.direction,
          collection_size: this.collectionSize,
          collection_from: Math.max(this.collectionSize * page - this.collectionSize * 2, 0),
        });
      }

      loadPreviousHandler(observerEntries) {
        observerEntries.forEach((entry) => {
          if (entry.isIntersecting == true) {
            entry.target.click();
          }
        });
      }

      onCardClicked(evt) {
        const link = evt.target.closest('a[data-product-url]');
        const target = evt.target.closest('v3-product-card');

        if (link) {
          const currentPage = target.id.split('C')[0].replace('P', '');

          const url = new URL(document.location.href);
          url.searchParams.set('page', currentPage);
          url.hash = target.id;

          history.replaceState('', null, url.toString());

          nostojs((api) => {
            api.recordSearchClick(this.trackType, {
              productId: target.dataset.productId,
              url: target.dataset.url,
            })
          })
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('v3-nosto-collection', V3NostoCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-video-image-50-50"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('video-image-5050')) {
  class VideoImage5050 extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.sectionId = this.dataset.sectionId;
      this.abortController = new AbortController();
      this.sliderContainer = this.querySelector('[data-slider]');
      this.videos = this.querySelectorAll('[data-video]');
      this.floatingImageContainer = this.querySelector('[data-floating-image-container]');
      this.slider = null;
      this.videoObserver = null;
      this.peekAnimationFired = false;
      this.visibilityObserver = null;

      this._initSlider();
      this._initVideoObserver();
      this._initPeekObserver();

      document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this), {
        signal: this.abortController.signal
      });
      document.addEventListener('shopify:section:select', this._onSectionSelect.bind(this), {
        signal: this.abortController.signal
      });
      document.addEventListener('shopify:section:deselect', this._onSectionDeselect.bind(this), {
        signal: this.abortController.signal
      });
      document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this), {
        signal: this.abortController.signal
      });
    }

    _initSlider() {
      if (!this.sliderContainer) return;
      if (this.sliderContainer.children.length <= 1) return;

      this.prevButton = this.querySelector('.video-image-5050__button--prev');
      this.nextButton = this.querySelector('.video-image-5050__button--next');

      this.slider = new tns({
        container: this.sliderContainer,
        items: 1,
        slideBy: 1,
        gutter: 0,
        mouseDrag: true,
        swipeAngle: 30,
        speed: 400,
        loop: false,
        rewind: false,
        autoplay: false,
        controls: true,
        controlsText: ['', ''],
        prevButton: this.prevButton,
        nextButton: this.nextButton,
        nav: true
      });

      this.slider.events.on('indexChanged', this._onSlideChange.bind(this));
      this._updateButtonStates();
    }

    _initVideoObserver() {
      if (this.videos.length === 0) return;

      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            this._playVideo(video);
          } else {
            this._pauseVideo(video);
          }
        });
      }, {
        rootMargin: '0px',
        threshold: 0.25
      });

      this.videos.forEach((video) => {
        this.videoObserver.observe(video);
      });
    }

    _getPeekThreshold() {
      const mobile = Math.min(50, Math.max(0, parseInt(this.dataset.animationThresholdMobile, 10) || 25)) / 100;
      const desktop = Math.min(50, Math.max(0, parseInt(this.dataset.animationThresholdDesktop, 10) || 50)) / 100;
      return window.matchMedia('(min-width: 750px)').matches ? desktop : mobile;
    }

    _initPeekObserver() {
      if (this.peekAnimationFired || !this.slider || !this.section) return;
      const slideCount = this.sliderContainer && this.sliderContainer.querySelectorAll('.video-image-5050__slide').length;
      if (slideCount <= 1) return;

      const threshold = this._getPeekThreshold();
      this.visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (this.peekAnimationFired) return;
          if (entry.intersectionRatio >= threshold) {
            this.peekAnimationFired = true;
            this._runPeekAnimation();
            if (this.visibilityObserver) {
              this.visibilityObserver.disconnect();
              this.visibilityObserver = null;
            }
          }
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5]
      });

      this.visibilityObserver.observe(this.section);
    }

    _parseTranslateXFromTransform(transformValue) {
      if (!transformValue || transformValue === 'none') return 0;
      const matrix = transformValue.match(/matrix\(([^)]+)\)/);
      if (matrix) {
        const parts = matrix[1].split(',').map((s) => s.trim());
        return parts.length >= 5 ? parseFloat(parts[4]) : 0;
      }
      const translate = transformValue.match(/translateX\(([^)]+)\)/);
      return translate ? parseFloat(translate[1]) : 0;
    }

    _runPeekAnimation() {
      if (!this.slider || !this.sliderContainer) return;

      const info = this.slider.getInfo();
      const currentSlide = info.slideItems[info.index];
      const nextSlide = currentSlide.nextElementSibling && currentSlide.nextElementSibling.classList.contains('video-image-5050__slide')
        ? currentSlide.nextElementSibling
        : (info.index < info.slideCount - 1 ? info.slideItems[info.index + 1] : null);

      if (!nextSlide) return;

      const tnsOuter = this.sliderContainer.closest('.tns-outer');
      const tnsInner = tnsOuter && tnsOuter.querySelector('.tns-inner');

      const duration = 800;
      const isMobile = !window.matchMedia('(min-width: 750px)').matches;
      const peekPx = isMobile ? 50 : 100;

      let trackStartTx = 0;
      if (tnsInner) {
        const computed = window.getComputedStyle(tnsInner);
        trackStartTx = this._parseTranslateXFromTransform(computed.transform);
      }

      const sliderEl = this.sliderContainer;

      this.style.setProperty('--peek-offset-x', '-' + peekPx + 'px');

      if (tnsInner) {
        tnsInner.style.transition = 'none';
        tnsInner.style.transform = 'translateX(0)';
      }

      sliderEl.style.transition = 'transform ' + (duration / 1000) + 's cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      sliderEl.style.transform = 'translateX(' + (trackStartTx - peekPx) + 'px)';

      window.setTimeout(() => {
        sliderEl.style.transform = 'translateX(' + trackStartTx + 'px)';

        window.setTimeout(() => {
          sliderEl.style.removeProperty('transition');
          sliderEl.style.removeProperty('transform');
          if (tnsInner) {
            tnsInner.style.removeProperty('transition');
            tnsInner.style.removeProperty('transform');
          }
          this.style.removeProperty('--peek-offset-x');
        }, duration);
      }, duration);
    }

    _destroySlider() {
      if (this.slider) {
        this.slider.destroy();
        this.slider = null;
      }
    }

    _destroyVideoObserver() {
      if (this.videoObserver) {
        this.videoObserver.disconnect();
        this.videoObserver = null;
      }
    }

    _playVideo(video) {
      if (!video) return;
      video.play().catch(() => {});
    }

    _pauseVideo(video) {
      if (!video) return;
      video.pause();
    }

    _onSlideChange(info) {
      this.videos.forEach((video) => {
        this._pauseVideo(video);
      });

      const currentSlide = info.slideItems[info.index];
      if (currentSlide) {
        const slideVideos = currentSlide.querySelectorAll('[data-video]');
        slideVideos.forEach((video) => {
          this._playVideo(video);
        });
      }

      this._updateButtonStates();
    }

    _getCurrentSlideElement() {
      if (this.slider) {
        const info = this.slider.getInfo();
        return info.slideItems[info.index] || null;
      }
      if (this.sliderContainer && this.sliderContainer.firstElementChild) {
        return this.sliderContainer.firstElementChild;
      }
      return null;
    }


    _updateButtonStates() {
      if (!this.slider || !this.prevButton || !this.nextButton) return;

      const info = this.slider.getInfo();
      const currentIndex = info.index;
      const slideCount = info.slideCount;

      this.prevButton.disabled = currentIndex === 0;
      this.nextButton.disabled = currentIndex === slideCount - 1;
    }

    _onSectionLoad(evt) {
      const sectionId = evt.detail.sectionId;
      if (this.section.id.replace('shopify-section-', '') === sectionId) {
        // Re-initialize slider and video observer when section is reloaded
        this._destroySlider();
        this._destroyVideoObserver();

        this.sliderContainer = this.querySelector('[data-slider]');
        this.videos = this.querySelectorAll('[data-video]');
        this.floatingImageContainer = this.querySelector('[data-floating-image-container]');

        this.peekAnimationFired = false;
        this._initSlider();
        this._initVideoObserver();
        this._initPeekObserver();
      }
    }

    _onSectionSelect(evt) {
      const sectionId = evt.detail.sectionId;
      if (this.section.id.replace('shopify-section-', '') === sectionId) {
        if (this.slider) {
          this.slider.goTo('first');
          this._updateButtonStates();
        }
      }
    }

    _onSectionDeselect(evt) {
      const sectionId = evt.detail.sectionId;
      if (this.section.id.replace('shopify-section-', '') === sectionId) {
        this.videos.forEach((video) => {
          this._pauseVideo(video);
        });
      }
    }

    _onBlockSelect(evt) {
      const sectionId = evt.detail.sectionId;
      const blockId = evt.detail.blockId;

      if (this.section.id.replace('shopify-section-', '') !== sectionId) return;

      const blockElement = this.querySelector(`[data-block-id="${blockId}"]`);
      if (blockElement && this.slider) {
        const slides = this.sliderContainer.querySelectorAll('.video-image-5050__slide');
        const slideIndex = Array.from(slides).indexOf(blockElement);
        if (slideIndex !== -1) {
          this.slider.goTo(slideIndex);
          this._updateButtonStates();
        }
      }
    }

    disconnectedCallback() {
      this.abortController.abort();
      if (this.visibilityObserver) {
        this.visibilityObserver.disconnect();
        this.visibilityObserver = null;
      }
      try {
        this._destroySlider();
      } catch (e) {
      }
      this._destroyVideoObserver();
    }
  }

  customElements.define('video-image-5050', VideoImage5050);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-video-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-preview')) {
    class VideoPreview extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.io = new IntersectionObserver(this.observerCallback.bind(this), {
          rootMargin: '300px',
          threshold: ['0', '0.01'],
        });
        this.overlayVideo = this.querySelector('[data-overlay-video]');
        this.fullVideo = this.querySelector('[data-full-video]');
        this.playButton = this.querySelector('.video-preview__play-button');
        this.videoPlaying = false;

        this.playButton.addEventListener('click', this.playVideo.bind(this), {
          signal: this.abortController.signal
        })

        this.fullVideo.addEventListener('pause', this.pauseVideo.bind(this, {playOverlay: true}), {
          signal: this.abortController.signal
        })
        this.io.observe(this);
      }

      observerCallback(entries) {
        entries.forEach((entry) => {
          if(!entry.isIntersecting) {
            if(this.videoPlaying) {
              this.pauseVideo({playOverlay: false});
            } else {
              this.overlayVideo.pause();
            }
          } else {
            if(this.overlayVideo) {
              this.overlayVideo.play();
            }
          }
        });
      }

      pauseVideo({playOverlay}) {
        if(this.fullVideo.ended == true) return;

        this.fullVideo.pause();
        this.classList.remove('is-playing');
        this.videoPlaying = false;

        if (this.overlayVideo && playOverlay == true) {
          this.overlayVideo.play();
          this.playButton.focus();
        }
      }

      playVideo() {
        if (this.overlayVideo) {
          this.overlayVideo.pause();
        }

        this.classList.add('is-playing');
        this.fullVideo.play();
        this.fullVideo.focus();
        this.videoPlaying = true;
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('video-preview', VideoPreview);
  }

  } catch(e) { console.error(e); }
})();
})();
